export default __webpack_public_path__ + "06113560501222d058530a8c51b16376.svg";